module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold-Oblique.b4270844.ttf";